export default "__VITE_ASSET__G1e4yyK8__"